
import Vue from "vue";
import PBXComponent from "@/components/signup/PBXComponent.vue";
export default Vue.extend({
  name: "SetupPBX",
  components: {
    PBXComponent
  }
});
